var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0.5H3C1.34315 0.5 0 1.84315 0 3.5V11.5C0 13.1569 1.34315 14.5 3 14.5H5C5.64911 14.5 6.28071 14.7105 6.8 15.1L8.2 16.15C9.26667 16.95 10.7333 16.95 11.8 16.15L13.2 15.1C13.7193 14.7105 14.3509 14.5 15 14.5C16.6569 14.5 18 13.1569 18 11.5V3.5C18 1.84315 16.6569 0.5 15 0.5ZM3 5.5C3 4.94772 3.44771 4.5 4 4.5H9C9.55228 4.5 10 4.94772 10 5.5C10 6.05228 9.55228 6.5 9 6.5H4C3.44771 6.5 3 6.05228 3 5.5ZM4 8.5C3.44771 8.5 3 8.94771 3 9.5C3 10.0523 3.44771 10.5 4 10.5H13C13.5523 10.5 14 10.0523 14 9.5C14 8.94771 13.5523 8.5 13 8.5H4Z",
    fill: "#0F973D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStep3);
export default __webpack_public_path__ + "static/media/ic_step3.b773ad2f7a73c9cf815257c671c529c7.svg";
export { ForwardRef as ReactComponent };